import {
  API,
  API_ERROR,
  LIST_RESOURCES,
  SET_RESOURCES,
  GET_RESOURCE,
  SET_RESOURCE,
  LIST_ASSET_EVENTS,
  SET_ASSET_EVENTS
} from '../actionTypes'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_RESOURCE:
      return {
        ...state,
        [action.resourceType]: {
          ...state[action.resourceType],
          [action.id]: {
            ...action.resource,
            isLoaded: true,
            isLoading: false
          }
        }
      }
    case SET_RESOURCES:
      const resources = {}
      for (let i = 0; i < Object.keys(action.resources).length; i++) {
        const resource = action.resources[Object.keys(action.resources)[i]]
        
        resources[resource[action.idField]] = {
          ...state[action.resourceType][resource[action.idField]],
          ...resource,
          isLoaded: true,
          isLoading: false
        }
      }
      
      return {
        ...state,
        [action.resourceType]: {
          ...state[action.resourceType],
          list: {
            isLoaded: true,
            isLoading: false,
            keys: Object.keys(action.resources)
          },
          ...resources
        }
      }
    case SET_ASSET_EVENTS:
      return {
        ...state,
        assets: {
          ...state.assets,
          [action.assetId]: {
            ...state.assets[action.assetId],
            events: {
              isLoaded: true,
              isLoading: false,
              Events: action.events.Events
            }
          }
        }
      }
    case API:
      if (action.payload.label === LIST_RESOURCES) {
        return {
          ...state,
          [action.payload.resourceType]: {
            ...state[action.payload.resourceType],
            list: {
              isLoaded: false,
              ...(state[action.payload.resourceType] || {}).list,
              isLoading: true
            }
          }
        }
      } else if (action.payload.label === GET_RESOURCE) {
        return {
          ...state,
          [action.payload.resourceType]: {
            ...state[action.payload.resourceType],
            [action.payload.resourceId]: {
              isLoaded: false,
              ...(state[action.payload.resourceType] || {})[action.payload.resourceId],
              isLoading: true
            }
          }
        }
      } else if (action.payload.label === LIST_ASSET_EVENTS) {
        return {
          ...state,
          assets: {
            ...state.assets,
            [action.payload.resourceId]: {
              ...(state.assets || {})[action.payload.resourceId],
              events: {
                isLoaded: false,
                ...((state.assets || {})[action.payload.resourceId] || {}).events,
                isLoading: true
              }
            }
          }
        }
      }
      return state
    case API_ERROR:
      // if (action.payload.label === LIST_RESOURCES) {
        // return {
          // ...state,
          // [action.payload.resourceType]: {
            // ...state[action.payload.resourceType],
            // error: action.error,
            // isLoaded: false,
            // isLoading: false,
            // isError: true
          // }
        // }
      // }
      return state
    default:
      return state
  }
}